<template>
  <div class="jl-auc-order-wrap">
    <div class="jl-container">
      <v-breadcrumbs></v-breadcrumbs>
      <div class="jl-auc-order-content">
        <div class="jl-auc-order_top">
          <p class="text1">填写并核对订单信息</p>
          <div class="jl-auc-order_process">
            <div class="pro-item active">
              <div class="pro-item-box-wrap">
                <div class="pro-line"></div>
                <div class="pro-item-box alt">1</div>
              </div>
              <p class="text-1">收货信息填写</p>
            </div>
            <div class="pro-item">
              <div class="pro-item-box-wrap">
                <div class="pro-line"></div>
                <div class="pro-item-box alt">2</div>
              </div>
              <p class="text-1">订单支付</p>
            </div>
            <div class="pro-item">
              <div class="pro-item-box-wrap">
                <div class="pro-item-box">3</div>
              </div>
              <p class="text-1">支付完成</p>
            </div>
          </div>
        </div>
        <div class="jl-auc-order_content">
          <div class="order-choose">
            <span class="text1">收货方式</span>
            <div class="order-choose-box1">
              <button
                v-for="(item, index) in receiveMethod"
                :key="index"
                :class="[receiveType == item.value?'btn active':'btn']"
                @click="chooseReceiveType(item)"
              >{{item.label}}</button>
              <p class="text-tips" v-if="receiveType === '1'">注意：请在选择自提后7天之内，8点到18点至荔虹锦鲤园取货，逾期视为已交货</p>
            </div>
          </div>
          <div class="order-address" v-if="receiveType === '2' || payType === '3'">
            <p class="text1">收货地址</p>
            <div class="order-address-content">
              <ul class="address-list clearfix">
                <li
                  v-for="(item, index) in orderAddressList"
                  :key="index"
                  :class="[orderAddressSelect === item.id?'item selected':'item']"
                  @click="selectAddress(item)"
                >
                  <div class="box-wrap">
                    <div class="box-top clearfix">
                      <p class="text2 f-l">{{item.consignee}}</p>
                      <p class="text2 f-r">{{item.contactPhone}}</p>
                    </div>
                    <div class="box-bottom">
                      <p class="text3">{{item.shippingAddress}}</p>
                    </div>
                    <p class="set-default" v-if="item.isDefault === 0">默认</p>
                    <div class="box-action">
                      <i class="jl-icon-bianji" @click.stop="updateAddress(item, index)"></i>
                      <i class="jl-icon-del" @click.stop="delAddress(item, index)"></i>
                    </div>
                  </div>
                </li>
                <li class="item plus">
                  <div class="box-wrap" @click="handleShowAddaddress">
                    <div class="item-plus-box">
                      <img src="@/assets/img/zkj-plus-icon.png" alt />
                      <p class="text4">添加新地址</p>
                    </div>
                  </div>
                </li>
              </ul>
            </div>
          </div>
          <div class="order-choose border-none">
            <span class="text1">付款方式</span>
            <div class="order-choose-box1">
              <template v-for="(item, index) in payMethod">
                <button
                  v-if="item.isShow"
                  :key="index"
                  :class="[payType == item.value?'btn active':'btn']"
                  @click="payType = item.value"
                >{{item.label}}</button>
              </template>
              <p
                class="text-tips"
                v-if="payType === '2'"
              >注意：请在{{overtime}}小时内加微信号：{{WeChartAccount}} 完成转账</p>
            </div>
          </div>
          <div class="order-product">
            <table class="table">
              <thead>
                <tr>
                  <th>商品消息</th>
                  <th>单价</th>
                  <th>数量</th>
                  <th>实付</th>
                </tr>
              </thead>
              <tbody>
                <template v-for="item in shopList">
                  <tr :key="item.id">
                    <td>
                      <div class="item-left">
                        <div class="item-l-img">
                          <img :src="item.image?item.image:item.imgsUrl" alt />
                        </div>
                        <div class="item-l-box">
                          <p class="text2">{{item.goods.name}}</p>
                          <p
                            class="text3"
                            v-if="item.series"
                          >系列：{{item.series}} / 颗粒：{{item.particles}} / 包装：{{item.pack}}</p>
                          <p class="text3" v-else-if="item.specification">规格：{{item.specification}}</p>
                        </div>
                      </div>
                    </td>
                    <td>
                      <p class="text1">￥ {{item.price}}</p>
                    </td>
                    <td>
                      <p class="text1 col-black">{{item.total? item.total : item.number}}</p>
                    </td>
                    <td>
                      <p
                        class="text1 col-black"
                      >￥ {{ item.totalPrice? item.totalPrice :(item.price * item.total) }}</p>
                    </td>
                  </tr>
                </template>
              </tbody>
            </table>
          </div>
          <div class="order-mark">
            <p class="text4">备注</p>
            <textarea
              class="mark-text"
              v-model="remark"
              name
              id
              cols="30"
              rows="10"
              placeholder="请输入备注信息 "
            ></textarea>
          </div>
        </div>
      </div>
      <div class="jl-auc-order_pay">
        <div class="pay-top clearfix" v-if="shopList.length > 0">
          <div class="pay-box">
            <p class="text1">
              应付总金额：
              <span class="span-1">¥</span>
              <span class="span-2">{{totalPrice}}</span>
            </p>
            <button class="pay-btn" @click="pay">
              {{orderPayType == 'auction'?'立即付款':'提交订单'}}
              <i
                class="el-icon-loading"
                v-if="isLoading"
              ></i>
            </button>
          </div>
        </div>
        <div class="pay-bottom">
          <p
            class="text1"
            v-if="receiveType === '2' &&  orderAddressText"
          >收货地址： {{orderAddressText}}</p>
        </div>
      </div>
    </div>
    <v-addAddress
      v-if="isShowAddaddress"
      :editData="editData"
      @closeAddAddress="handleCloseAddaddress"
      @addList="addAddressList"
    ></v-addAddress>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import Breadcrumbs from '@/components/Breadcrumbs';
import AddAddress from '@/components/AddAddress';
import { getUserAddressList, delAddress, delCart } from '../api/shop';
import {
  addOrder,
  updataAuctionOrder,
  overTime,
  getWeChartAccount
} from '../api/order';
export default {
  props: {
    orderPayType: {
      type: String,
      default: ''
    }
  },
  components: {
    'v-breadcrumbs': Breadcrumbs,
    'v-addAddress': AddAddress
  },
  data() {
    return {
      isShowAddaddress: false,
      receiveMethod: [
        {
          value: '1',
          label: '自提'
        },
        {
          value: '2',
          label: '快递'
        }
      ],
      receiveType: '2',
      payMethod: [
        /* {
          value: "1",
          label: "货到付款",
          isShow: true
        }, */
        {
          value: '0',
          label: '在线支付',
          isShow: true
        },
        {
          value: '2',
          label: '微信转账',
          isShow: true
        }
      ],
      payType: '0',
      orderAddressList: [],
      orderAddressSelect: '',
      orderAddressText: '',
      isLoading: false,
      editData: {}, //编辑数据
      totalPrice: '', //总金额
      shopList: [],
      waitPaidPrice: '',
      remark: '',
      overtime: '',
      WeChartAccount: ''
    };
  },
  computed: {
    ...mapGetters(['userInfo', 'cartItemData'])
  },
  created() {
    overTime(this);
    getWeChartAccount(this);
    getUserAddressList(this);
    this.getShopList();
  },
  destroyed() {
    document.body.className = '';
  },
  beforeRouteLeave(to, from, next) {
    window.localStorage.setItem('shopInfo', JSON.stringify({}));
    next();
  },
  methods: {
    chooseReceiveType(item) {
      this.receiveType = item.value;
      if (this.receiveType === '1') {
        this.payType = '0';
      } else {
        this.payMethod[0].isShow = true;
      }
    },
    //获取订单商品列表
    getShopList() {
      // let obj = JSON.parse(window.localStorage.getItem("shopInfo"));
      let obj = this.cartItemData;
      this.totalPrice = obj.totalPrice || '';
      this.shopList = obj.list || [];
      this.waitPaidPrice = obj.waitPaidPrice;
      //console.log(obj);
    },
    //更新收货地址
    updateAddress(item) {
      this.editData = item;
      this.isShowAddaddress = true;
      document.body.className = 'overActive';
    },
    //删除收货地址
    delAddress(item, index) {
      this.$confirm('确定删除该条地址?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          let param = {
            id: item.id
          };
          delAddress(this, param, res => {
            if (res.code == 200) {
              this.$notify({
                title: '提示',
                message: '删除成功！',
                type: 'success'
              });
              this.orderAddressList.splice(index, 1);
              if (item.id == this.orderAddressSelect) {
                this.orderAddressSelect = '';
                this.orderAddressText = '';
              }
            } else {
              this.$notify({
                title: '提示',
                message: '删除失败：' + JSON.stringify(res),
                type: 'success'
              });
            }
          });
        })
        .catch(() => {
          console.log('取消');
        });
    },
    //提交订单 || 更新订单
    pay() {
      var list = this.shopList.map(e => {
        let item = {};
        item.goodsId = e.goodsId;
        item.name = e.goods.name;
        item.series = e.series;
        item.particles = e.particles;
        item.pack = e.pack;
        item.specification = e.specification;
        item.number = e.total ? e.total : e.number;
        item.price = e.price;
        item.totalPrice = e.totalPrice ? e.totalPrice : e.total * e.price;
        return item;
      });
      this.paydata = {
        userId: this.userInfo.userId,
        orderPrice: this.totalPrice,
        waitPaidPrice: this.totalPrice,
        receiveWay: this.receiveType == '1' ? 0 : 1,
        payMethod: this.payType,
        payType: this.payType == 2 ? 1 : '',
        addressId: this.orderAddressSelect,
        remark: this.remark
      };
      if (!this.orderPayType) return; //没有订单类型
      this.paydata.orderGoodsType = this.orderPayType === 'shop' ? 1 : 0; //orderGoodsType '0 拍卖订单 1商品订单
      if (this.$route.query.id) {
        this.paydata.id = this.$route.query.id;
      }

      if (this.receiveType == 2 && !this.orderAddressSelect) {
        this.$notify({
          title: '提示',
          message: '请选择收货地址',
          type: 'error'
        });
        return;
      }
      this.isLoading = true;
      if (this.orderPayType == 'auction') {
        //更新订单
        this.paydata.auctionId = this.shopList[0].goods.auctionId;
        updataAuctionOrder(this, res => {});
      } else {
        //下订单
        this.paydata.list = list;
        addOrder(this, () => {
          let shopIds = [];
          this.shopList.forEach(item => {
            shopIds.push(item.id);
          });
          delCart(this, shopIds);
        });
      }
    },
    //添加修改地址成功后台review
    addAddressList(obj) {
      this.handleCloseAddaddress();
      getUserAddressList(this);
    },
    //选择收货地址
    selectAddress(item) {
      this.orderAddressSelect = item.id;
      this.orderAddressText =
        item.consignee + ' ' + item.contactPhone + ' ' + item.shippingAddress;
    },
    //关闭增加地址模态框
    handleCloseAddaddress() {
      this.isShowAddaddress = false;
      document.body.className = '';
    },
    //开启增加地址模态框
    handleShowAddaddress() {
      this.editData = {};
      this.isShowAddaddress = true;
      document.body.className = 'overActive';
    }
  }
};
</script>

<style lang="scss" scoped>
.jl-auc-order-wrap {
  background: #f8f8fb;
  padding-bottom: 180px;
}
.jl-container {
  max-width: 1200px;
  margin-left: auto;
  margin-right: auto;
}
.f-l {
  float: left;
}
.f-r {
  float: right;
}
.jl-auc-order-content {
  background: #fff;
}
.jl-auc-order_top {
  position: relative;
  height: 132px;
  &::after,
  &::before {
    content: '';
    position: absolute;
    bottom: 0;
    left: -14px;
    width: 28px;
    height: 28px;
    border-radius: 28px;
    background: #f8f8fb;
  }
  &::after {
    left: auto;
    right: -14px;
  }
  .text1 {
    font-size: 24px;
    color: #333;
    padding-top: 40px;
    padding-left: 37px;
  }
}
.jl-auc-order_content {
  padding: 0 40px;
  .order-choose {
    padding-top: 20px;
    padding-bottom: 20px;
    border-bottom: 1px solid #e0e0e0;
    .order-choose-box1 {
      display: inline-block;
      vertical-align: middle;
      .text-tips {
        font-size: 14px;
        color: #e50011;
        padding-left: 23px;
        background: url('../assets/img/zkj-o-tip.png') no-repeat left center;
        margin-top: 16px;
      }
    }
    .text1,
    .btn {
      display: inline-block;
      vertical-align: top;
    }
    .text1 {
      font-size: 14px;
      color: #1f1f1f;
      margin-right: 40px;
      line-height: 1;
      margin-top: 11px;
    }
    .btn {
      position: relative;
      width: 104px;
      height: 36px;
      text-align: center;
      line-height: 36px;
      font-size: 14px;
      color: #333;
      border: 1px solid #666;
      background-color: #fff;
      margin-right: 16px;
      outline: none;
      cursor: pointer;
      &::before {
        content: '';
        position: absolute;
        top: -2px;
        right: -2px;
        width: 0;
        height: 0;
        background: url('../assets/img/zkj-order-select.png') no-repeat center
          center;
        background-size: cover;
      }
      &.active {
        border: 2px solid #e50011;
        &::before {
          width: 14px;
          height: 14px;
        }
      }
    }
    &.border-none {
      border: none;
    }
  }
  .order-address-content {
    padding-bottom: 22px;
    border-bottom: 1px solid #e0e0e0;
  }
  .order-address {
    .text1 {
      font-size: 14px;
      color: #1f1f1f;
      padding-top: 20px;
      padding-bottom: 15px;
    }
    .address-list {
      margin-left: -10px;
      margin-right: -10px;
      .item {
        float: left;
        width: 25%;
        padding: 0 10px;
        margin-bottom: 20px;
        height: 158px;
        cursor: pointer;
        .box-wrap {
          position: relative;
          background-color: #f8f8fb;
          height: 100%;
          .set-default {
            position: absolute;
            left: 10px;
            bottom: 10px;
            font-size: 12px;
            border: 1px solid #e50011;
            color: #e50011;
            width: 30px;
            text-align: center;
          }
        }
        &.selected .box-wrap {
          border: 2px solid #e50011;
          background: #fff;
        }
        .box-action {
          position: absolute;
          right: 10px;
          bottom: 10px;
          i {
            font-size: 18px;
            color: #e50011;
          }
        }
      }
      .box-top {
        border-bottom: 1px solid #e0e0e0;
        padding: 16px 20px;
        .text2 {
          font-size: 16px;
          color: #333;
        }
      }
      .box-bottom {
        padding: 16px 20px;
        .text3 {
          font-size: 14px;
          color: #666;
          line-height: 24px;
        }
      }
      .item.plus .box-wrap {
        position: relative;
        width: 100%;
        height: 100%;
        background-color: #f8f8fb;
        border: 1px solid #e0e0e0;

        .item-plus-box {
          position: absolute;
          left: 50%;
          top: 50%;
          width: 100%;
          transform: translate(-50%, -50%);
          text-align: center;
          .text4 {
            font-size: 14px;
            columns: #999;
          }
        }
      }
    }
  }
  .order-product {
    .table {
      width: 100%;
      max-width: 100%;
      border-spacing: 0;
      border-collapse: collapse;
      border: 1px solid #e0e0e0;
      thead {
        background: #f6f6f6;
        border-bottom: 1px solid #e0e0e0;
      }
      th {
        font-size: 14px;
        color: #666;
        font-weight: 500;
        padding: 12px 0;
        text-align: center;
        width: 17.5%;
        &:first-child {
          padding-left: 20px;
          text-align: left;
          width: 47.5%;
        }
      }
      tbody {
        td {
          text-align: center;
          &:first-child {
            text-align: left;
          }
        }
        .text1 {
          font-size: 14px;
          color: #666;
          &.col-black {
            color: #333;
            font-weight: bold;
          }
        }
        .item-left {
          position: relative;
          padding: 20px 0 20px 20px;
          height: 145px;
          .item-l-img {
            position: absolute;
            left: 20px;
            top: 20px;
            display: inline-block;
            vertical-align: middle;
            overflow: hidden;
            width: 80px;
            height: 105px;
            text-align: center;
            &::after {
              content: '';
              display: inline-block;
              vertical-align: middle;
              width: 0;
              height: 100%;
            }
            img {
              display: inline-block;
              vertical-align: middle;
              max-height: 100%;
              max-width: 100%;
            }
          }
        }
        .item-l-box {
          display: inline-block;
          vertical-align: middle;
          padding-left: 100px;
          .text2 {
            font-size: 18px;
            color: #333;
            line-height: 30px;
          }
          .text3 {
            font-size: 14px;
            color: #666;
            line-height: 30px;
          }
        }
        tr {
          border-bottom: 1px solid #e0e0e0;
          &:last-child {
            border-bottom: none;
          }
        }
      }
    }
  }
  .order-mark {
    padding-top: 20px;
    padding-bottom: 30px;
    .text4 {
      font-size: 14px;
      color: #333;
      margin-bottom: 10px;
    }
    .mark-text {
      display: block;
      width: 100%;
      max-width: 100%;
      font-size: 14px;
      color: #333;
      border: 1px solid #f0f0f0;
      background: #fafafa;
      padding: 15px;
    }
  }
}
.jl-auc-order_pay {
  margin-top: 10px;
  background: #fff;
  .pay-top {
    padding: 18px 40px;
    border-bottom: 1px solid #e0e0e0;
    .pay-box {
      float: right;
      text-align: right;
      .text1 {
        font-size: 14px;
        color: #666;
      }
      .span-1 {
        font-size: 14px;
        color: #e50011;
        margin-right: 3px;
      }
      .span-2 {
        font-size: 24px;
        color: #e50011;
      }
      .pay-btn {
        width: 156px;
        height: 42px;
        font-size: 14px;
        color: #fff;
        background-color: #e50011;
        line-height: 42px;
        text-align: center;
        cursor: pointer;
        outline: none;
        margin-top: 20px;
      }
    }
  }
  .pay-bottom {
    .text1 {
      font-size: 14px;
      color: #666;
      text-align: right;
      padding: 17px 40px;
    }
  }
}

.jl-auc-order_process {
  position: absolute;
  right: 0;
  top: 25px;
  .pro-item {
    display: inline-block;
    width: 138px;
    &.active {
      .text-1 {
        color: #12a624;
      }
      .pro-item-box {
        background: #12a624;
        &.alt::before {
          background: #12a624;
        }
      }
      .pro-line {
        border-top-color: #12a624;
      }
      .pro-line::before {
        border-top-color: #12a624;
        border-right-color: #12a624;
      }
    }
  }
  .pro-item-box-wrap {
    position: relative;
  }
  .pro-line {
    position: absolute;
    right: -36%;
    top: 50%;
    transform: translateY(-50%);
    width: 68%;
    height: 1px;
    border-top: 1px dashed #ccc;
    &::before {
      content: '';
      position: absolute;
      right: 0;
      top: -5px;
      width: 8px;
      height: 8px;
      border-top: 1px solid #e2e8ef;
      border-right: 1px solid #e2e8ef;
      transform: rotate(45deg);
    }
  }
  .pro-item-box {
    position: relative;
    width: 24px;
    height: 24px;
    border-radius: 50%;
    background: #e2e8ef;
    font-size: 16px;
    color: #fff;
    text-align: center;
    line-height: 24px;
    margin-left: auto;
    margin-right: auto;
    &.alt::before {
      content: '';
      position: absolute;
      width: 8px;
      height: 8px;
      background: #e2e8ef;
      transform: rotate(-45deg);
      top: 8px;
      right: -2px;
    }
  }
  .text-1 {
    font-size: 14px;
    color: #333;
    margin-top: 15px;
    text-align: center;
  }
}
</style>
